import { useEffect, useRef, useState, type ReactNode } from 'react';

export default function Toast({ children, onClose, ms = 8000 }: {
  children: ReactNode;
  onClose: () => void;
  ms?: number;
}) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const close = useRef(onClose);
  close.current = onClose;
  const [round, setRound] = useState(0);
  const [held, setHeld] = useState(false);

  const stop = () => { if (timer.current) clearTimeout(timer.current); };
  const start = () => {
    stop();
    timer.current = setTimeout(() => close.current(), ms);
  };

  useEffect(() => { start(); return stop; }, []);

  return (
    <div className="toast" role="status"
         onMouseEnter={() => { stop(); setHeld(true); }}
         onMouseLeave={() => { start(); setHeld(false); setRound((r) => r + 1); }}>
      <span className="toast-icon" aria-hidden="true">
        <svg viewBox="0 0 16 16" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2.4"
             strokeLinecap="round" strokeLinejoin="round"><path d="M3 8.5l3.2 3L13 4.5" /></svg>
      </span>
      {children}
      <button className="toast-x" aria-label="Close" onClick={onClose}>×</button>
      {!held && <span key={round} className="toast-time" style={{ animationDuration: `${ms}ms` }} />}
    </div>
  );
}
